import axios from 'axios';
import config from '@/config';

const baseUrl = `${config.ctx.iffApi}/jxxf/pg`;

export const pgExecutionService = {
  catalog: xmId => axios.get(`${baseUrl}/execution/${xmId}/catalog`),
  detail: xmnrId => axios.get(`${baseUrl}/execution/content/${xmnrId}`),
  save: (xmnrId, data) => axios.put(`${baseUrl}/execution/content/${xmnrId}`, data)
};
